import {Shower} from "../../parts/shower";
import {IntermediatePart} from "../../intermediatePart";
import {SIDE_POSITIONS} from "../../constants";
// import {SIDE_POSITIONS} from "../../constants";

export default class AccessoryCommon extends IntermediatePart {

  constructor(props) {
    super(props);
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

  checkRelatedFeatureGroupPositions(position) {
    const accessoriesParent = this.getParent();
    const showerParent = accessoriesParent.layout.parts[Shower.id]; // no need for another check
    const showerSize = showerParent.showerSize();
    let otherFeatureGroup = null;
    switch (this.partId) {
      case "grab_bar":
        otherFeatureGroup = accessoriesParent.soapDish;
        break;
      case "soap_dish":
        otherFeatureGroup = accessoriesParent.grabBar;
        break;
      case "shower_seats":
        otherFeatureGroup = accessoriesParent.largeCornerSeat;
        break;
      case "large_corner_seat":
        otherFeatureGroup = accessoriesParent.seats;
        break;
      default:
        break;
    }
    if (showerSize === "30") {
      if (otherFeatureGroup) {
        Object.keys(otherFeatureGroup.layerPositions).forEach(key => {
          otherFeatureGroup.layerPositions[key] = null
        })
      }
    } else {
      if (this.layerPositions && this.layerPositions[position] && otherFeatureGroup && otherFeatureGroup.layerPositions[position] && !otherFeatureGroup.disabled) {
        const newPosition = position === SIDE_POSITIONS[0] ? SIDE_POSITIONS[1] : SIDE_POSITIONS[0];
        if (!this.layerPositions[newPosition]) {
          const matchingPositionFeature = otherFeatureGroup.getMatchingPositionFeature(newPosition, otherFeatureGroup.layerPositions[position]);
          if (matchingPositionFeature) {
            otherFeatureGroup.layerPositions[newPosition] = matchingPositionFeature;
          }
        }
        otherFeatureGroup.layerPositions[position] = null; //2) remove old soap dish position
      }
    }
  }

}
